module.exports = __webpack_public_path__ + "static/media/logo-orange.33ad2755.png";